'use client'

import React, { useState } from 'react'
import Link from 'next/link'
import BallPileIcon from 'src/app/assets/icons/ico-ball-pile.svg'
import { sendOtp, verifyOtp } from './_actions/login.actions'

export default function LoginPage() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [email, setEmail] = useState('')
  const [otpSent, setOtpSent] = useState(false)
  const [otp, setOtp] = useState('')

  const handleSendOtp = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setIsLoading(true)
    setError(null)

    const formData = new FormData()
    formData.append('email', email)
    const result: any = await sendOtp(formData)

    if (result?.error) {
      setError(result.error)
      setIsLoading(false)
    } else {
      setOtpSent(true)
      setIsLoading(false)
    }
  }

  const handleVerifyOtp = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setIsLoading(true)
    setError(null)

    const formData = new FormData()
    formData.append('email', email)
    formData.append('token', otp)
    const result: any = await verifyOtp(formData)

    if (result?.error) {
      setError(result.error)
      setIsLoading(false)
    }
  }

  return (
    <main>
      <div className="login">
        <div className="login-container">
          <div className="login-container__top">
            <div className="primary-logo big">
              <span className="icon">
                <img src="/assets/marbles_symbol-white.webp" alt="Marbles" />
              </span>
            </div>
          </div>
          <div className="login-container__inner">
            <div className="login__header">
              <span>Login to Marbles</span>
            </div>
            {!otpSent ? (
              <form className="login__form" onSubmit={handleSendOtp}>
                {error && <div className="error-message">{error}</div>}
                <div className="form-group label-on-top">
                  <label htmlFor="email">Email:</label>
                  <input
                    id="email"
                    placeholder="Email"
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button
                  className={`login_btn ${isLoading ? 'loading' : ''}`}
                  type="submit"
                  disabled={isLoading}
                >
                  <span>Login</span>
                  <BallPileIcon />
                </button>
              </form>
            ) : (
              <form className="login__form" onSubmit={handleVerifyOtp}>
                {error && <div className="error-message">{error}</div>}
                <div className="form-group label-on-top">
                  <label htmlFor="otp">Enter OTP:</label>
                  <input
                    id="otp"
                    placeholder="Enter OTP"
                    name="otp"
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                  />
                </div>
                <button
                  className={`login_btn ${isLoading ? 'loading' : ''}`}
                  type="submit"
                  disabled={isLoading}
                >
                  <span>Verify OTP</span>
                  <BallPileIcon />
                </button>
              </form>
            )}
          </div>
        </div>
        <div className="login-background"></div>
      </div>
    </main>
  )
}
